module.exports = __webpack_public_path__ + "img/parachute-octobre-8.90692822.jpg";